<template>
  <el-container>
    <el-main style="padding: 0">
      <div class="mainBox departmentTree">
        <div class="treeMenu" :style="{ height: mainBoxHeight + 'px' }">
          <el-input v-model="filterText" placeholder="请输入部门名称" />
          <el-tree
            ref="tree"
            :filter-node-method="filterNode"
            accordion
            class="filter-tree"
            :data="data"
            :highlight-current="true"
            node-key="id"
            @node-click="nodeClick"
          />
        </div>
        <div class="treeContent">
          <vm-table
            ref="vmTable"
            class="departmentTable"
            :filter.sync="filter"
            module="basic"
            url="departments"
            @select="selectHandler"
            @select-all="selectHandler"
          >
            <div slot="toolbar">
              <el-button v-if="addAuth" type="primary" @click="$refs.editDepartment.open()">新建</el-button>
              <el-button v-if="selection.length > 0 && delAuth" type="danger" @click="deleteBatch">批量删除</el-button>
            </div>
            <template slot="adSearch">
              <div class="vm-search">
                <vm-search label="查询：">
                  <el-input v-model.trim="filter.filter" placeholder="请输入关键字查询" clearable />
                </vm-search>
              </div>
            </template>
            <el-table-column type="selection" align="center" width="55" prop="selection" />
            <el-table-column type="index" align="center" label="#" width="55" prop="index" />
            <el-table-column prop="departmentNO" align="center" label="部门编号" />
            <el-table-column prop="outerNO" align="center" label="外部编号" />
            <el-table-column prop="departmentName" align="left" min-width="120" show-overflow-tooltip label="部门名称" />
            <el-table-column prop="directorName" align="center" label="部门主管" />
            <el-table-column prop="parentName" align="left" min-width="120" show-overflow-tooltip label="上级部门" />
            <el-table-column prop="telephone" align="center" min-width="120" label="电话" />
            <el-table-column label="操作" align="center" width="120px" prop="action">
              <template slot-scope="scope">
                <el-button v-if="editAuth" type="primary" @click="$refs.editDepartment.open(scope.row.departmentID)">编辑</el-button>
                <el-button v-if="delAuth" type="danger" @click="deleteDepartment(scope.row.departmentID)">删除</el-button>
              </template>
            </el-table-column>
          </vm-table>
          <!-- 编辑 -->
          <department-edit ref="editDepartment" @save-success="getDepartmentList()" />
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import VmTable from "@/components/VmTable.vue";
import VmSearch from "@/components/VmSearch.vue";
import DepartmentEdit from "@/views/information/Department/DepartmentEdit";
export default {
  components: {
    VmTable,
    VmSearch,
    DepartmentEdit,
  },

  data() {
    return {
      addAuth: this.$auth(114),
      editAuth: this.$auth(115),
      delAuth: this.$auth(116),
      mainBoxHeight: 0,
      data: [],
      filterText: "",
      filter: {
        parentID: "",
        filter: "",
      },
      selection: [],
    };
  },

  // 监听部门关键字
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  created() {
    this.getDepartmentList();
  },

  mounted() {
    this.setMainBoxHeight();
    window.onresize = () => {
      this.setMainBoxHeight();
    };
  },

  methods: {
    // 动态设置mainBox的高度
    setMainBoxHeight() {
      var clientHeight = document.body.clientHeight;
      this.mainBoxHeight = clientHeight - 90;
    },

    // 查询部门树形列表
    getDepartmentList() {
      this.$http.get("basic", "departments/tree").then((res) => {
        if (res.success) {
          this.data = [{ id: 0, label: "全  部", parentId: 0, children: null }];
          this.data = this.data.concat(res.data);
          // 设置默认选中第一个节点
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(0);
            this.filter.parentID = 0;
            this.getList(1);
          });
        }
      });
    },

    // 根据关键字过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 查询所有的部门列表
    getList() {
      this.$refs.vmTable.getList(1);
    },

    // 节点被点击时
    nodeClick(row) {
      this.filter.parentID = row.id;
      this.getList(1);
      this.$refs.tree.setCurrentKey(row.id);
    },

    // 单个删除部门
    deleteDepartment(departId) {
      this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
        this.$http.delete("basic", "departments", departId).then((resp) => {
          if (resp.success) {
            this.getDepartmentList();
            this.$message.success("删除成功");
          }
        });
      });
    },

    // checkBox
    selectHandler(selection) {
      this.selection = selection;
    },

    // 批量删除部门
    deleteBatch() {
      var ids = [];
      this.selection.forEach((item) => {
        ids.push(item.departmentID);
      });
      this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
        this.$http.delete("basic", "departments/idList", ids).then((resp) => {
          if (resp.success) {
            this.getDepartmentList();
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.mainBox {
  overflow: hidden;
}

.treeMenu {
  width: 200px;
  overflow-y: scroll;
  padding: 0 10px;
  margin-right: 10px;
  box-sizing: border-box;
  float: left;
}

.departmentTable {
  width: calc(100% - 210px);
  float: right;
}

.el-tree {
  margin-top: 10px;
}
</style>

<style>
.departmentTree .el-tree-node__label {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
